/* eslint-disable react/prop-types */
/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from 'emotion';

import { TextFontStyles } from './styles';
import { TextColor } from '../styles/colors';

import LinkIconImg from './icons/outline-launch-24px.svg';
import ImageIconImg from './icons/outline-image-24px.svg';
import VideoIconImg from './icons/outline-movie-24px.svg';
import PdfIconImg from './icons/outline-picture_as_pdf-24px.svg';

const Container = styled.li`
  position: relative;
  margin-bottom: 15px;
  list-style-type: none;
`;

const TypeStyles = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 32px;
  height: 32px;

  background-size: 100% 100%;
  background-repeat: no-repeat;
`;

const TypeExtStyles = {
  pdf: css`
    background-image: url(${PdfIconImg});
  `,
  image: css`
    background-image: url(${ImageIconImg});
  `,
  video: css`
    background-image: url(${VideoIconImg});
  `,
  link: css`
    background-image: url(${LinkIconImg});
  `,
  notype: css`
    display: none;
  `,
};

const Body = styled.div`
  ${TextFontStyles};

  padding-left: ${({ type }) => (type === 'notype' ? '0' : '55px')};
`;

const LinkList = styled.ul`
  padding: 0;
`;

const LinkItem = styled.li`
  list-style-type: none;
  padding-left: 55px;

  text-overflow: ellipsis;
  overflow: hidden;

  a, a:hover, a:visited {
    ${TextFontStyles};
  }
`;

const LINK_TARGET = '_blank';
const LINK_REL = 'noopener noreferrer';

const Link = ({ href, download }) => (
  <LinkItem>
    { download
      ? (
        <a href={href} download={download}>{ download }</a>
      ) : (
        <a href={href} target={LINK_TARGET} rel={href && href[0] === '/' ? undefined : LINK_REL}>{ href && href.replace(/^\/[^/]+\//g, '') }</a>
      )
    }
  </LinkItem>
);

const parseAutoLinks = text => text.replace(
  /(https?:\/\/[^ ]*[^ ,.])/g,
  `<a href="$1" style="color:${TextColor}" target="${LINK_TARGET}" rel="${LINK_REL}">$1</a>`,
);

const Urls = ({ url, download }) => (
  Array.isArray(url)
    ? (
      <LinkList>
        { url.map(href => (
          <Link key={href} href={href} />
        )) }
      </LinkList>
    ) : (
      <LinkList>
        <Link href={url} download={download} />
      </LinkList>
    )
);

const ExternalSource = ({ type, body, url, download }) => (
  <Container>
    <div className={css([TypeStyles, TypeExtStyles[type]])} />
    <Body type={type} dangerouslySetInnerHTML={{ __html: parseAutoLinks(body) }} />
    <Urls url={url} download={download} />
  </Container>
);

ExternalSource.propTypes = {
  type: PropTypes.oneOf(['link', 'pdf', 'image', 'video', 'notype']),
  body: PropTypes.string.isRequired,
  download: PropTypes.string,
  url: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

ExternalSource.defaultProps = {
  type: 'notype',
  url: undefined,
  download: undefined,
};

export default ExternalSource;



// WEBPACK FOOTER //
// ./src/components/ExternalLinksCollection/ExternalSource.js